import React from "react";
import { Form, Table } from "react-bootstrap";

class Questions_Table_MEDAS extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.data || {};
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data && this.props.data) {
      this.setState(this.props.data);
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...this.state, [name]: value };

    this.setState(updated, () => {
      // Calculate individual scores for each question and add them as flat properties
      const scoreData = {};
      this.props.questions.forEach((q) => {
        scoreData[`${q.id}_score`] = this.getQuestionScore(q);
      });

      const medas_score = this.computeScore();
      const adherence_category = this.getAdherenceCategory(medas_score);

      if (this.props.handler) {
        // Forward the answers, individual scores, total score, and adherence category
        this.props.handler({
          ...this.state,
          ...scoreData,
          medas_score,
          adherence_category
        });
      }
    });
  };

  renderOptions = (name, options) => {
    return (
      <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
        {options.map((opt, idx) => (
          <Form.Check
            type="radio"
            label={opt}
            name={name}
            id={`${name}_${idx}`}
            value={opt}
            key={idx}
            checked={this.state[name] === opt}
            onChange={this.handleChange}
            disabled={this.props.disabled}
            style={{ margin: 0 }}
          />
        ))}
      </div>
    );
  };

  renderFreeEntry = (name, note) => {
    const numericPattern = /\bdays? per week\b|\bhours? per day\b|\bhow long\b/i;
    const isNumeric = numericPattern.test(note || name);

    return (
      <Form.Control
        type={isNumeric ? "number" : "text"}
        name={name}
        value={this.state[name] || ""}
        onChange={this.handleChange}
        placeholder={note || "Enter your answer"}
        disabled={this.props.disabled}
        min={isNumeric ? 0 : undefined}
        max={isNumeric ? 24 : undefined}
      />
    );
  };

  getQuestionScore = (q) => {
    if (q.options && this.state[q.id] === q.options[0]) {
      return 1;
    }
    return 0;
  };

  renderTableRow = (q, index) => {
    const score = this.getQuestionScore(q);
    
    return (
      <tr key={q.id}>
        <td style={{ width: '5%', textAlign: 'center', verticalAlign: 'middle' }}>
          <strong>{index + 1}</strong>
        </td>
        <td style={{ width: '50%', verticalAlign: 'middle' }}>
          <strong>{q.question}</strong>
          {q.note && (
            <div style={{ fontSize: '0.9em', color: '#666', marginTop: '4px' }}>
              {q.note}
            </div>
          )}
        </td>
        <td style={{ width: '35%', verticalAlign: 'middle', padding: '8px 12px' }}>
          {q.options
            ? this.renderOptions(q.id, q.options)
            : this.renderFreeEntry(q.id, q.note)}
        </td>
        <td style={{ width: '10%', textAlign: 'center', verticalAlign: 'middle' }}>
          <strong>{score}</strong>
        </td>
      </tr>
    );
  };

  getAdherenceCategory = (score) => {
    if (score <= 5) return "Low adherence";
    else if (score <= 9) return "Moderate adherence";
    else return "High adherence";
  };

  computeScore = () => {
    let score = 0;
    this.props.questions.forEach((q) => {
      if (q.options && this.state[q.id] === q.options[0]) {
        score += 1;
      }
    });
    return score;
  };

  renderScoreSummary = () => {
    const score = this.computeScore();
    const category = this.getAdherenceCategory(score);

    return (
      <div className="mt-4">
        <h5>Total Score: {score} / 14</h5>
        {category && <p>Adherence Category: <strong>{category}</strong></p>}
      </div>
    );
  };

  renderGroupedTables = () => {
    const grouped = {};
    this.props.questions.forEach((q) => {
      const group = q.table || "MEDAS Questionnaire";
      if (!grouped[group]) grouped[group] = [];
      grouped[group].push(q);
    });

    return Object.entries(grouped).map(([section, questions]) => (
      <div key={section} className="mb-4">
        <h5 className="mb-3">{section}</h5>
        <Table bordered hover responsive>
          <thead style={{ backgroundColor: '#f8f9fa' }}>
            <tr>
              <th style={{ width: '5%', textAlign: 'center' }}>#</th>
              <th style={{ width: '50%' }}>QUESTION</th>
              <th style={{ width: '35%', textAlign: 'center' }}>
                PLEASE TICK THE BOX THAT APPLIES TO YOU
              </th>
              <th style={{ width: '10%', textAlign: 'center' }}>SCORE</th>
            </tr>
          </thead>
          <tbody>
            {questions.map((q, index) => this.renderTableRow(q, index))}
          </tbody>
        </Table>
      </div>
    ));
  };

  render() {
    return (
      <>
        {this.renderGroupedTables()}
        {this.renderScoreSummary()}
      </>
    );
  }
}

Questions_Table_MEDAS.defaultProps = {
  data: {},
  handler: null,
  disabled: false,
};

export default Questions_Table_MEDAS;